// src/components/SectionTitle.jsx
import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

const SectionTitle = ({ title, subtitle, center }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={`mb-8 ${center ? "text-center" : "text-left"}`}
    >
      {subtitle && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wider">
          {subtitle}
        </p>
      )}
      <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white">
        {title}
      </h2>
      <div className="w-16 h-1 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 mt-2 rounded-full mx-auto"></div>
    </motion.div>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  center: PropTypes.bool,
};

SectionTitle.defaultProps = {
  subtitle: "",
  center: false,
};

export default SectionTitle;